import { Component } from 'react'

import * as h from 'h'

import styles from './styles.scss'

import { browserHistory } from 'react-router'
import HistoryTracker from 'back-forward-history'

export default class BackLink extends Component {
  goBack () {
    browserHistory.goBack()
  }

  render () {
    const previousLocationTitle =
      HistoryTracker.canGoBack() &&
      HistoryTracker.getCurrentLocationTitle(-1)

    const showBackLink =
      !HistoryTracker.isCurrentlyOnTag('initial popout') &&
      previousLocationTitle

    return h.maybe(showBackLink, h.z({ onClick: this.goBack, ...h.ca(styles.backLink) },
      h.icon({ name: 'arrow-circle-o-left' }),
      'Back to ' + previousLocationTitle))
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/Popout/BackLink.js